import React, { useEffect, useState } from "react";
import { db, auth } from "../../firebase/firebase";
import { useNavigate } from "react-router-dom";
import "./AdminSection.css";

export const AdminSection = () => {
  const [userData, setuserData] = useState([]);
  // const [Loading, setLoading] = useState(true);
  //   const user = location.state;
  const [userInfo, setuserInfo] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      if (auth && auth.currentUser) {
        db.collection("userInfo")
          .orderBy("createdAT", "desc")
          .get()
          .then((snapshot) => {
            const newData = snapshot.docs.map((doc) => ({ ...doc.data(), ID: doc.id }));
            setuserData(newData);
          });
        // setLoading(false);
        setuserInfo(auth.currentUser.email);
      } else {
        navigate("/");
      }
    }, 1000);
  }, []);

  return (
    <section className="mt-5">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 d-flex align-items-center flex-column">
            <span className="header_heading mb-3">رفع مستوى المسح</span>
            <span className="userEmail">مسؤل : {userInfo}</span>
          </div>
        </div>
      </div>
      <div className="container mt-5">
        <table className="table table-striped table-bordered text-center">
          <thead>
            <tr className="p-2">
              <th scope="col">#</th>
              <th scope="col">اسم االمستخدم</th>
              <th scope="col">رقم المستخدم</th>
              <th scope="col">مبيعات مختارة</th>
              <th scope="col">التسويق الحالي</th>
              <th scope="col">الدخل الشهري</th>
              <th scope="col">نص المشكلة</th>
            </tr>
          </thead>
          <tbody>
            {userData.map((res, index) => {
              return (
                <tr key={index}>
                  <th scope="row">{index + 1}</th>
                  <td>{res.userName}</td>
                  <td>{res.userNumber}</td>
                  <td>{res.userSelectSales}</td>
                  <td>
                    {res.userUsingCurrentMarketing.map((res) => {
                      return (
                        <ul className="d-flex">
                          <li>{res}</li>
                        </ul>
                      );
                    })}
                  </td>
                  <td>{res.userMontlyIncome}</td>
                  <td>{res.userProblemFacingText}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
};
